import {CreatePopup} from "components/Admin/Pages/CreatePopup/CreatePopup";
import {DateInput} from "react-admin";
import {seasonService} from "../../../services/seasonService";

export const SeasonCreate = () => {
  return (
    <CreatePopup createQuery={seasonService.create}>
      <DateInput source="startDate" fullWidth />
    </CreatePopup>
  );
};